<form
  [ngClass]="{ 'dados-referencia__box blue-box': indexReferencia }"
  [formGroup]="dadosReferenciaForm"
>
  <div class="form-group">
    <span class="icon reference"></span>
    <div class="inputs">
      <label for="user-reference"
        >Nome da {{ getIndexReferencia() }} Referência</label
      >
      <input
        class="form-control"
        type="text"
        placeholder="Digite..."
        maxlength="40"
        appShowErrorMessages
        formControlName="nome"
        name="nome"
        required
        uppercase
        minlength="3"
        [charOnly]="true"
        requiredMessage="Nome da Referencia é obrigatório"
      />
    </div>
  </div>

  <div class="form-group">
    <span class="icon mobile"></span>
    <div class="inputs">
      <label for="user-phone"
        >Celular da {{ getIndexReferencia() }} Referência</label
      >
      <input
        type="user-phone"
        formControlName="foneCelular"
        appOnlyDigitsLengthValidator
        appShowErrorMessages
        [minLength]="11"
        [maxLength]="15"
        class="form-control"
        placeholder="(00) 00000-0000"
        appTelefone
        appCelularValidator
        genericErrorMessage
        (focus)="clearErrorMessage()"
      />
      <div class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
    </div>
  </div>

  <div class="form-group">
    <span class="icon"></span>

    <div class="inputs field-group__pesados">
      <label for="user-reference-relation">Relação com o Cliente</label>
      <select
        id="user-reference-relation"
        class="form-control"
        name="idGrauRelacionamento"
        required
        appShowErrorMessages
        requiredMessage="Relação com o Cliente é obrigatório"
        formControlName="idGrauRelacionamento"
        (change)="onChangeRelacaoCliente()"
      >
        <option value="" selected hidden>Selecione...</option>
        <option value="1">Amigo</option>
        <option value="2">Parente</option>
        <option value="3">Vizinho</option>
        <option value="4">Outros</option>
      </select>

      <input
        id="relacaoClienteOutro"
        *ngIf="showRelacaoClienteOutro"
        type="text"
        autocomplete="off"
        class="form-control field-group__outro"
        name="relacaoClienteOutro"
        formControlName="relacaoClienteOutro"
        placeholder="Digite outra Relação com o Cliente..."
        minlength="1"
        maxlength="30"
        (blur)="onBlurRelacaoClienteOutro()"
        uppercase
      />
      <div
        class="text-danger"
        *ngIf="
          showRelacaoClienteOutro &&
          (relacaoClienteOutro.value === '' ||
            relacaoClienteOutro.value === null) &&
          relacaoClienteOutroTouched
        "
      >
        Campo Obrigatório
      </div>
    </div>
  </div>
</form>
